// Have the courage to follow your heart and intuition.

import "./app.css";
import "svgmap/dist/svgMap.min.css";

import "flowbite";
import "./sidebar";
import "./wysiwyg";
import "./dark-mode";
import "../core/static/js/alpinejs";
import "./tags-select-field";

import ApexCharts from "apexcharts";
window.ApexCharts = ApexCharts;
import "../core/static/js/analytics-charts";


// Workaround for datepicker
document.querySelectorAll('.date_input').forEach(input => {
    input.addEventListener('changeDate', function () {
        const e = new Event('change', { bubbles: true });
        this.dispatchEvent(e);
    });
});
